import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getBaseUrl } from "../../utils/general/getBaseUrl";
import { CUSTOMER } from "../../utils/constants/customer.constants";
import { baseQueryWithReauth } from "@states/auth/auth.api";

export const reportApi = createApi({
    reducerPath: "reportApi",
    tagTypes: ["Report"],
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getSalesByProduct: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page = 1, limit = 10, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/sales-by-products",
                    params: { page, limit },
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getAllInventoryReport: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                search?: string | number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page = 1, limit = 10, search, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/inventory-report",
                    params: { page, limit },
                };

                if (search) {
                    //@ts-ignore
                    queryParams.params.search = search;
                }

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),

        getAllDeliveryOrderByItem: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page = 1, limit = 10, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/delivery-order-by-item-report",
                    params: { page, limit },
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getAllDeliveryOrderByCustomer: builder.query<
            [],
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/delivery-order-by-customer-report",
                    params: {},
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        // useGetAllInventoryReportQuery
        getSalesByProductCustomer: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page = 1, limit = 10, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/sales-by-products-customer",
                    params: { page, limit },
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getSalesByProductCategory: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page = 1, limit = 10, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/sales-by-product-categories",
                    params: { page, limit },
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getDeliveredGoodIssue: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page = 1, limit = 10, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/delivered-good-issue",
                    params: { page, limit },
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getPendingDeliveryGoodIssues: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page = 1, limit = 10, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/pending-delivery-good-issues",
                    params: { page, limit },
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getAllCustomerSalesAnalysis: builder.query<
            [],
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/customer-sales-analysis-report",
                    params: {},
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getIssuedItemByRequestReason: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ page = 1, limit = 10, from_date, to_date }) => {
                const queryParams = {
                    url: "reports/issued-item-by-request-reason",
                    params: { page, limit },
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        exportDeliveredGoodIssue: builder.query<
            Blob,
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/delivered-good-issue/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        exportPendingDeliveryGoodIssue: builder.query<
            Blob,
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/pending-delivery-good-issues/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        exportIssuedItemByRequestReason: builder.query<
            Blob,
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/issued-item-by-request-reason/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        exportInventoryReport: builder.query<
            Blob,
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/inventory-report/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        exportDeliveryOrderByItem: builder.query<
            Blob,
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/delivery-order-by-item-report/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        exportSalesByProduct: builder.query<
            Blob,
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/sales-by-products/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getAllConsignmentReport: builder.query<
            [],
            {
                page?: number;
                limit?: number;
                from_date?: string;
                to_date?: string;
                customer_id?: number;
                business_unit_id?: number;
            }
        >({
            query: ({ page = 1, limit = 10, from_date, to_date, customer_id, business_unit_id }) => {
                const queryParams = {
                    url: "consignment/report",
                    params: { page, limit },
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                if (customer_id) {
                    //@ts-ignore
                    queryParams.params.customer_id = customer_id;
                }

                if (business_unit_id) {
                    //@ts-ignore
                    queryParams.params.business_unit_id = business_unit_id;
                }

                return queryParams;
            },
        }),
        exportSalesByProductCustomer: builder.query<
            Blob,
            {
                from_date?: string;
                to_date?: string;
            }
        >({
            query: ({ from_date, to_date }) => {
                const queryParams = {
                    url: "reports/sales-by-products-customer/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                return queryParams;
            },
        }),
        getReceivablesReport: builder.query<
            [],
            {
                from_date?: string;
                to_date?: string;
                customer_id?: number;
            }
        >({
            query: ({ from_date, to_date, customer_id }) => {
                const queryParams = {
                    url: "reports/receivables-report",
                    params: {},
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                if (customer_id) {
                    //@ts-ignore
                    queryParams.params.customer_id = customer_id;
                }

                return queryParams;
            },
        }),
        exportReceivablesReport: builder.query<
            Blob,
            {
                from_date?: string;
                to_date?: string;
                customer_id?: number;
            }
        >({
            query: ({ from_date, to_date, customer_id }) => {
                const queryParams = {
                    url: "reports/receivables-report/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (from_date) {
                    //@ts-ignore
                    queryParams.params.from_date = from_date;
                }

                if (to_date) {
                    //@ts-ignore
                    queryParams.params.to_date = to_date;
                }

                if (customer_id) {
                    //@ts-ignore
                    queryParams.params.customer_id = customer_id;
                }

                return queryParams;
            },
        }),
        getSalesTargetReport: builder.query<
            any,
            {
                assignee_id?: number;
                product_target_ids?: (string | number | Date)[]
            }
        >({
            query: ({ assignee_id, product_target_ids }) => {
                const queryParams = {
                    url: "reports/sales-target-report",
                    params: {},
                };

                if (assignee_id) {
                    //@ts-ignore
                    queryParams.params.assignee_id = assignee_id;
                }

                if(product_target_ids){
                    //@ts-ignore
                    queryParams.params.product_target_ids =  product_target_ids;
                }

                return queryParams;
            },
        }),
        exportSalesTargetReport: builder.query<
            Blob,
            {
                assignee_id?: number;
                product_target_ids: (string | number | Date)[]
            }
        >({
            query: ({ assignee_id,product_target_ids }) => {
                const queryParams = {
                    url: "reports/sales-target-report/export",
                    params: {},
                    responseHandler: (response: Response) => response.blob(),
                };

                if (assignee_id) {
                    //@ts-ignore
                    queryParams.params.assignee_id = assignee_id;
                }

                if(product_target_ids){
                    //@ts-ignore
                    queryParams.params.product_target_ids = product_target_ids;
                }

                return queryParams;
            },
        }),
    }),
    keepUnusedDataFor: 0,
});

export const {
    useGetSalesByProductQuery,
    useGetSalesByProductCategoryQuery,
    useGetSalesByProductCustomerQuery,
    useGetDeliveredGoodIssueQuery,
    useGetIssuedItemByRequestReasonQuery,
    useGetPendingDeliveryGoodIssuesQuery,
    useGetAllInventoryReportQuery,
    useGetAllDeliveryOrderByItemQuery,
    useGetAllDeliveryOrderByCustomerQuery,
    useGetAllCustomerSalesAnalysisQuery,
    useGetAllConsignmentReportQuery,
    useGetReceivablesReportQuery,
    useGetSalesTargetReportQuery,
    useLazyExportDeliveredGoodIssueQuery,
    useLazyExportPendingDeliveryGoodIssueQuery,
    useLazyExportIssuedItemByRequestReasonQuery,
    useLazyExportInventoryReportQuery,
    useLazyExportDeliveryOrderByItemQuery,
    useLazyExportSalesByProductQuery,
    useLazyExportSalesByProductCustomerQuery,
    useLazyExportReceivablesReportQuery,
    useLazyExportSalesTargetReportQuery,
} = reportApi;
